import { render, staticRenderFns } from "./EInvoiceConfiguration.vue?vue&type=template&id=5d20f984&"
import script from "./EInvoiceConfiguration.js?vue&type=script&lang=js&"
export * from "./EInvoiceConfiguration.js?vue&type=script&lang=js&"
import style0 from "./EInvoiceConfiguration.vue?vue&type=style&index=0&id=5d20f984&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports